import { render, staticRenderFns } from "./CrudCard.vue?vue&type=template&id=fc22d4e6&scoped=true&"
import script from "./CrudCard.ts?vue&type=script&lang=js&"
export * from "./CrudCard.ts?vue&type=script&lang=js&"
import style0 from "./CrudCard.vue?vue&type=style&index=0&id=fc22d4e6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc22d4e6",
  null
  
)

export default component.exports